import initialState from '../initialState.js';
import {
    GET_NOTIFICATIONS_SUCCESS,
    REMOVE_NOTIFICATION_SUCCESS
} from '../../actions/types/notifications';

export default (state = initialState.notifications, action) => {
    switch (action.type) {
        case GET_NOTIFICATIONS_SUCCESS: {
            return {
                ...state,
                items: action.notifications
            };
        }

        case REMOVE_NOTIFICATION_SUCCESS: {
            return {
                ...state,
                items: state.items.filter((item) => item.id !== action.id)
            };
        }

        default:
            return state;
    }
};